<template>
  <div class="columns is-vcentered">
    <div class="column is-padding-bottom">
      <label class="label is-padding-bottom-small">
        Utilisateur(s) ayant accès au pôle
        <span class="tag has-text-weight-normal is-xsmall is-primary is-margin-left-xsmall">
          {{sharedU.length}}
        </span>
      </label>
      <span class="is-inline-block is-vcentered is-margin-right-xsmall is-margin-bottom-xsmall is-selected tooltip is-tooltip-bottom"
            v-for="(u, i) in sharedU" :key="u.pk" :data-tooltip="`${u.first_name} ${u.last_name}`">
        <avatar :item="u" :i="i" :removeDataCallback="u.user" @remove="deleteShareUser"></avatar>
      </span>
      <button class="button is-circle is-border" @click="openAddNewSharedUser">
        <i class="fal fa-plus fa-lg"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'SharedUsersPanel',
    props: {
      pole: {
        type: Object,
        required: true
      },
      sharedUsers: {
        type: Array,
        required: true
      }
    },
    computed: {
      ...mapState(['quickview']),
      p () {
        return this.pole
      },
      polePk () {
        return this.pole.pk
      },
      sharedU () {
        if (!Array.isArray(this.sharedUsers)) return []
        else return this.sharedUsers
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            if (params.shared) {
              this.addNewSharedUser(results.entities)
            }
          }
        }
      }
    },
    methods: {
      openAddNewSharedUser () {
        let sharedUserPk = this.sharedU.map(x => x.user)
        let params = {
          excludes: sharedUserPk,
          mode: 'append',
          shared: true,
          facets: {
            'USER': ['is_external:False', 'is_editor:False', 'is_operator:False']
          }
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      addNewSharedUser (user) {
        let sharedUserPk = user.map(x => x.pk)
        let params = {
          accesses: sharedUserPk
        }
        this.$api.poleService.postSharedUsers(this.polePk, params).then(r => {
          r.data.forEach(x => {
            this.sharedU.push(x)
            this.p.accesses.unshift(x)
          })
          this.$notify({
            type: 'is-success',
            text: 'Accés ajouté'
          })
        })
      },
      deleteShareUser (id) {
        this.$api.poleService.deleteSharedUsers(this.polePk, id).then(() => {
          let idx = this.sharedU.findIndex(x => x.user === id)
          this.sharedU.splice(idx, 1)
          this.p.accesses.splice(idx, 1)
          this.$notify({
            type: 'is-success',
            text: 'Accés supprimé'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pole/PolePanel/SharedUsersPanel.vue